import { Clock, ChefHat } from 'lucide-react';
import { formatMinutes, hasTime, NO_TIME_LABEL, totalMinutes } from '../utils/recipeTime';

// Renders whichever of prep/cook are known, plus a "Total" chip when a published total adds
// information they don't (many sites publish one figure instead of a split), and
// "Time not set" when nothing is known. What's shown always matches what
// effectiveTotalMinutes filters on, so the list can't disagree with the detail view.
// A total is displayed but never added to prep or cook — it already includes the cook time.
// Callers supply itemClassName because the detail view and the card use different spacing.
export function RecipeTimeChips({ recipe, itemClassName = 'flex items-center gap-2' }) {
  const { prepTime, cookTime, totalTime } = recipe;
  const hasBreakdown = hasTime(prepTime) || hasTime(cookTime);
  const knownParts = totalMinutes(prepTime, cookTime);

  // Shown when the total says something the visible parts don't. Suppressed when the
  // breakdown is complete, and when the total merely restates the one part we have (the
  // common "cookTime 30, totalTime 30" shape) — otherwise it reads as duplication.
  const showTotal =
    hasTime(totalTime) && !(hasTime(prepTime) && hasTime(cookTime)) && totalTime !== knownParts;

  if (!hasBreakdown && !showTotal) {
    return (
      <div className={itemClassName}>
        <Clock className="w-4 h-4" />
        <span>{NO_TIME_LABEL}</span>
      </div>
    );
  }

  return (
    <>
      {hasTime(prepTime) && (
        <div className={itemClassName}>
          <ChefHat className="w-4 h-4" />
          <span>Prep {formatMinutes(prepTime)}</span>
        </div>
      )}
      {hasTime(cookTime) && (
        <div className={itemClassName}>
          <Clock className="w-4 h-4" />
          <span>Cook {formatMinutes(cookTime)}</span>
        </div>
      )}
      {showTotal && (
        <div className={itemClassName}>
          <Clock className="w-4 h-4" />
          <span>Total {formatMinutes(totalTime)}</span>
        </div>
      )}
    </>
  );
}
